import styled from 'styled-components';
import { AccountBalanceImage } from './AccountBalanceImage';
import { AccountInfoPath } from './AccountInfoPath';
import { AlgoStrategiesImage } from './AlgoStrategiesImage';
import { LiveAccountPath } from './LiveAccountPath';
import { LogoImage } from './LogoImage';
import { OrderHistoryImage } from './OrderHistoryImage';
import { PortfolioImage } from './PortfolioImage';

const Icon = styled.svg.attrs({
	xmlns: 'http://www.w3.org/2000/svg',
	fill: 'none'
})``;

const SvgSmall = styled(Icon).attrs({
	fill: 'currentColor',
	className: 'bi bi-three-dots-vertical',
	viewBox: '0 0 16 16'
})`
	width: 20px;
	height: 20px;
`;

export const ThreeDots = () => (
	<SvgSmall>
		<path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
	</SvgSmall>
);

const Chevron = styled(Icon).attrs({
	viewBox: '0 0 448 512'
})`
	width: 20px;
	height: 20px;
`;

export const DownChevron = () => (
	<Chevron>
		<path
			fill="currentColor"
			d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
	</Chevron>
);

export const Logo = () => (
	<Icon>
		<LogoImage />
	</Icon>
);

export const EditPencil = () => (
	<Icon>
		<rect opacity="0.4" x="0.351562" width="31.1558" height="31.1558" fill="url(#pattern0)" />
		<defs>
			<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
				<use xlinkHref="#image0_43_6498" transform="scale(0.0111111)" />
			</pattern>
			<image
				id="image0_43_6498"
				width="90"
				height="90"
				xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACY0lEQVR4nO3cMWsUQRiH8SeXJliI6SRlKuFEhBRpUohcaap8A1sLQQubgNcIfoqQxNqApE1AxK/gFzAxrYKiMYmcxV7gLrm92915553s7v8HW+5meJjMzoTcgYiIiIiIiNxoD4F3wDfgDDgGtoH7KQfVNC+BC2Aw4ToHnqUbWnP0mRz46rWZaoBNUDSyYgcoG1mxK6gaOSj2fOioa2gV6AXc/xj4B3yyGU6zvSJsVmsZKSF0CRmgrV9hobHPgW6RH9TGNXrUR2AOeFTx/g5wC/hgNqKGC5nZXxOM98boD6+y91QJ/ddmyPUzGswj9pHJqGtmUqjYsXcsBl4n0wLFin0BPDAYe20UCRMj9guDsddGmV/1tyWfPe0E+dpg7LVR5eVlEVuRC14hsRW55FVlzS57T61ZRK46s1vDMrJi54gRWbGviBlZsYc8Irc+tmfkqLE7MR5qpE+aPeufBD8zmRQzeYAOI4psTZEdKLIDRXagyA4U2YEiO1BkB4rsQJEdKLIDRXagyA4U2YEiO1BkB4rsQJEdKLKTZeA58BlFdtMF9ogbuVX/cDjNEzSTXdxFkd2coMgu9lFkF1ZbPkWeweKFqMgFhL4QFbmERWCN7DCzC3xBkd0sAevkH2p0GDF2D83kXCvGzxtdSjSThzpkX5Bq+fGDyy2gZvKIHvazr2v4rMbYYnw9be2nmGJaAL5z/eWl2MY2yN/zKrah90w/YCi2gdvAb2af5hQ70FOKHZtPsN9nt8oB+XF/kO1GeugrOIP9ZDzuKdnfKTbIdiNi5A3wCzgkW0bupB2OiIiIiIiImPkPk3wiQ2ABNIIAAAAASUVORK5CYII="
			/>
		</defs>
	</Icon>
);

export const LiveAccountIcon = () => (
	<Icon className="tab-icon">
		<LiveAccountPath />
		<defs>
			<clipPath id="clip0_34_1060">
				<rect width="27" height="27" fill="white" />
			</clipPath>
		</defs>
	</Icon>
);

export const PaperAccountIcon = () => (
	<Icon className="tab-icon">
		<g clipPath="url(#clip0_33_1029)" filter="url(#filter0_d_33_1029)">
			<path
				d="M18.6401 4.8C18.6401 4.28 18.6601 3.76 18.6601 3.22C19.6201 3.52 20.4801 3.56 21.0201 2.5C22.5001 2.72 23.9401 3.12 25.4401 3.26C29.6201 3.64 33.8201 3.38 38.0001 3.46C39.2601 3.48 39.2601 3.46 39.2601 4.76C39.2801 10.64 39.2801 16.54 39.3001 22.42C38.9001 22.66 38.4601 22.54 38.0401 22.54C33.9601 22.58 29.9001 22.6 25.8201 22.62C24.7601 22.72 23.7201 22.86 22.6801 23.1C22.1201 23.22 21.5401 23.48 20.9601 23.18C20.4801 23.04 20.1401 22.58 19.6201 22.54C19.6201 22.08 19.6401 21.64 19.6401 21.18C24.3201 21.18 29.0201 21.16 33.7001 21.18C34.4001 21.18 34.7601 21.04 34.8201 20.22C34.9401 18.86 35.5401 17.7 37.0201 17.36C37.6201 17.22 37.7401 16.96 37.7401 16.42C37.7201 14.12 37.7201 11.84 37.7401 9.54C37.7401 8.96 37.5201 8.76 36.9801 8.62C35.5401 8.26 34.5801 7.32 34.4801 5.82C34.4201 4.9 34.0201 4.84 33.3001 4.84C28.4001 4.84 23.5201 4.82 18.6401 4.8Z"
				fill="#FF6B01"
			/>
			<path
				d="M16.5598 12.76C16.2598 12.26 16.8798 12.32 16.9798 12.04C17.4798 12.04 17.3798 11.6 17.4798 11.32C18.4998 8.58004 21.4798 7.10004 23.9598 7.96004C25.3798 8.46004 26.2998 9.48004 27.1998 10.56C27.1598 10.7 27.2198 10.8 27.3598 10.86C27.4998 11.6 27.6798 12.32 27.6598 13.14C27.5998 14.84 26.5398 16.88 24.9998 17.6C23.2798 18.42 21.5598 18.42 19.8398 17.6C18.7198 16.84 17.9598 15.8 17.4198 14.58C17.3198 14 17.2598 13.42 17.1398 12.86C17.0398 12.42 16.7998 12.5 16.5598 12.76Z"
				fill="#FF6B01"
			/>
			<path
				d="M18.64 4.80011C23.52 4.82011 28.42 4.84011 33.3 4.82011C34.02 4.82011 34.42 4.88011 34.48 5.80011C34.6 7.28012 35.54 8.24012 36.98 8.60012C37.52 8.74012 37.76 8.94011 37.74 9.52011C37.72 11.8201 37.72 14.1001 37.74 16.4001C37.74 16.9401 37.62 17.2001 37.02 17.3401C35.54 17.6801 34.94 18.8401 34.82 20.2001C34.76 21.0401 34.4 21.1601 33.7 21.1601C29.02 21.1401 24.32 21.1601 19.64 21.1601C18.98 20.8401 18.28 21.0201 17.6 20.9801C17.22 20.9601 17.12 21.1401 17.2 21.5401C17.34 22.1001 17.04 22.3201 16.48 22.2601C15.88 22.2201 15.3 22.2201 14.7 22.2001C13.94 22.1601 13.3 22.1001 12.84 23.0001C12.46 23.7401 11.26 23.8001 10.52 23.3201C9.70001 22.7801 9.54001 21.8601 10.06 20.8001C10.34 20.8001 10.42 21.0401 10.52 21.2401H10.5C10.04 21.4401 10.18 21.7001 10.4 22.0001C10.66 22.6401 11.06 23.1001 11.82 22.8801C12.62 22.6401 12.72 22.0001 12.58 21.3001C12.6 21.0601 12.68 20.8401 12.96 20.7601C13.22 21.3201 13.6 21.6001 14.26 21.5601C14.88 21.5201 15.52 21.5801 16.16 21.6001C16.52 21.6001 16.76 21.4801 16.66 21.0801C16.44 20.2001 16.98 20.2401 17.56 20.2801C22.7 20.5201 27.86 20.4001 33 20.4601C33.78 20.4601 34.06 20.2801 34.22 19.4801C34.46 18.2201 35.16 17.2001 36.46 16.7801C36.96 16.6201 37 16.3201 37 15.9001C36.98 13.9801 36.98 12.0401 37 10.1201C37 9.66012 36.88 9.44011 36.42 9.26012C35.04 8.70012 33.98 7.84012 33.88 6.20011C33.84 5.74011 33.48 5.64012 33.04 5.64012C28.56 5.66012 24.08 5.68011 19.58 5.68011C19.34 5.68011 19.12 5.68011 18.88 5.68011C18.54 5.66011 18.22 5.62012 17.88 5.62012C17.16 5.62012 16.34 5.78011 16.46 4.58011C16.5 4.24011 16.2 4.26011 15.96 4.26011C15.4 4.26011 14.82 4.28011 14.26 4.26011C13.68 4.24011 13.26 4.32012 12.9 4.94011C12.34 5.90012 11.02 5.96011 10.22 5.22011C9.48001 4.52011 9.48001 3.24011 10.24 2.56011C11.02 1.86011 12.3 1.90011 12.86 2.82011C13.28 3.50011 13.76 3.66011 14.46 3.56011C14.96 3.50011 15.46 3.58011 15.96 3.52011C16.72 3.46011 17.16 3.52011 17.26 4.50011C17.32 5.20011 18.14 4.72011 18.64 4.80011ZM10.38 3.76011C10.36 4.48011 10.76 4.90012 11.38 4.94011C12.06 4.98011 12.54 4.58011 12.58 3.88011C12.6 3.18011 12.18 2.76011 11.48 2.74011C10.8 2.74011 10.44 3.14011 10.38 3.76011Z"
				fill="black"
			/>
			<path
				d="M39.2999 22.4201C39.2799 16.5401 39.2799 10.6401 39.2599 4.76009C39.2599 3.46009 39.2599 3.48009 37.9999 3.46009C33.8199 3.38009 29.6199 3.64009 25.4399 3.26009C23.9399 3.12009 22.4999 2.72009 21.0199 2.50009C20.6599 1.82009 21.4999 2.16009 21.5799 1.84009C24.3399 2.46009 27.1399 2.74009 29.9799 2.70009C32.9799 2.66009 35.9599 2.70009 38.9599 2.68009C39.7199 2.68009 39.9999 2.86009 39.9999 3.68009C39.9599 9.86009 39.9599 16.0601 39.9999 22.2401C39.9999 23.0601 39.7399 23.2401 38.9799 23.2201C35.0799 23.1801 31.1999 23.2001 27.2999 23.2001C26.8999 23.2001 26.4999 23.2401 26.1199 23.2801C24.6199 23.3601 23.1799 23.7601 21.6999 23.9801C21.0399 24.0801 20.9799 23.6401 20.9599 23.1601C21.5599 23.4401 22.1199 23.2001 22.6799 23.0801C23.7199 22.8601 24.7599 22.7001 25.8199 22.6001C26.0199 22.8601 26.2999 22.7801 26.5599 22.7801C30.6999 22.7801 34.8599 22.7801 38.9999 22.7801C39.1599 22.7801 39.3999 22.8401 39.4799 22.7601C39.7799 22.5001 39.4399 22.5001 39.2999 22.4201ZM39.5999 21.3401C39.6399 21.3601 39.6599 21.3601 39.6999 21.3801C39.6999 15.6801 39.6999 10.0001 39.6999 4.30009C39.6599 4.30009 39.6399 4.30009 39.5999 4.30009C39.5999 9.98009 39.5999 15.6601 39.5999 21.3401Z"
				fill="black"
			/>
			<path
				d="M4.7201 10.4599C5.2201 10.4399 5.7201 10.4399 6.2001 10.3999C6.7201 10.3599 7.1801 10.5399 7.3401 11.0199C7.6001 11.7799 8.1401 11.8399 8.8001 11.8199C9.7001 11.7799 10.6001 11.8399 11.4801 11.7999C12.0401 11.7799 12.4201 11.8999 12.3601 12.5399C12.3001 13.1599 12.6201 13.2399 13.1401 13.2199C13.7601 13.1999 14.4001 13.2399 15.0201 13.2599C15.2601 13.2599 15.4801 13.2999 15.4801 13.6399C15.4801 13.9599 15.2801 13.9999 15.0201 13.9999C14.0601 13.9599 13.1001 13.8999 12.1401 13.8799C11.6601 13.8599 11.6001 13.5399 11.6401 13.1999C11.7001 12.5999 11.4201 12.4799 10.8801 12.4999C10.3201 12.5399 9.7601 12.4999 9.1801 12.4999C8.3801 12.4999 7.6801 12.4199 7.1201 13.3599C6.5801 14.2799 5.5201 14.0799 4.6201 13.6199C4.3801 13.1399 3.6601 12.7599 4.3001 12.0799C4.5601 12.3799 4.7401 12.6999 5.0001 12.9399C5.5201 13.4199 6.1001 13.4199 6.6001 12.9399C7.1201 12.4199 7.1401 11.7999 6.6401 11.2599C6.1201 10.7199 5.5201 10.7399 4.9801 11.2599C4.7201 11.5199 4.5201 12.1199 4.1201 11.7799C3.7801 11.4799 4.2801 11.0999 4.4601 10.7799C4.5201 10.6399 4.6201 10.5599 4.7201 10.4599Z"
				fill="black"
			/>
			<path
				d="M27.2001 10.5599C26.3001 9.47989 25.4001 8.4399 23.9601 7.9599C21.4801 7.0999 18.5001 8.5799 17.4801 11.3199C17.3801 11.5999 17.4801 12.0399 16.9801 12.0399C16.6001 11.7199 16.7401 11.3399 16.8801 10.9599C17.7401 8.6999 19.6801 7.0999 22.3201 7.0199C24.8601 6.9399 27.0601 8.4399 27.9601 10.7999C27.7401 10.8199 27.5401 10.8399 27.3201 10.8399C27.3001 10.7599 27.2401 10.6599 27.2001 10.5599Z"
				fill="black"
			/>
			<path
				d="M27.3399 10.8601C27.5599 10.8401 27.7599 10.8201 27.9799 10.8201C28.9799 13.2201 28.2799 15.9601 26.2399 17.6401C24.3199 19.2401 21.4799 19.4001 19.3799 18.0201C19.3999 17.7401 19.5599 17.6201 19.8399 17.6001C21.5599 18.4401 23.2799 18.4401 24.9999 17.6001C26.5399 16.8601 27.5799 14.8201 27.6399 13.1201C27.6599 12.3201 27.4999 11.6001 27.3399 10.8601Z"
				fill="black"
			/>
			<path
				d="M6.45996 6.42008C6.59996 5.54008 7.37996 5.56008 7.97996 5.46008C8.67996 5.34008 9.35996 5.68008 9.61996 6.34008C9.89996 6.98008 10.3 7.08008 10.9 7.08008C11.8 7.06008 12.7 7.10008 13.58 7.12008C13.82 7.12008 14.18 7.08008 14.24 7.20008C14.62 7.94008 14.86 8.78008 15.9 8.82008C15.88 8.92008 15.9 9.06008 15.86 9.10008C15.42 9.42008 14.9 9.20008 14.42 9.22008C14.04 9.24008 13.86 8.98008 13.92 8.64008C14.02 7.92008 13.68 7.82008 13.06 7.84008C12.24 7.88008 11.4 7.88008 10.58 7.80008C10.06 7.76008 9.79996 8.00008 9.57996 8.38008C9.53996 8.10008 9.43996 7.84008 9.21996 7.64008C9.23996 7.00008 9.09996 6.44008 8.39996 6.24008C7.69996 6.02008 7.25996 6.36008 6.91996 6.92008C6.77996 6.74008 6.61996 6.58008 6.45996 6.42008Z"
				fill="black"
			/>
			<path
				d="M9.80002 17.58C10.98 17.86 12.18 17.72 13.38 17.8C13.78 17.84 13.88 17.64 13.92 17.28C14.04 16.56 15.22 16.12 15.78 16.6C15.86 16.68 15.94 16.84 15.92 16.94C15.86 17.16 15.64 17.24 15.44 17.2C14.8 17.1 14.56 17.34 14.58 18C14.6 18.58 14.14 18.54 13.72 18.52C12.42 18.48 11.12 18.46 9.84002 18.44C9.38002 18.48 9.30002 18.68 9.58002 19.02C8.80002 20.02 8.12002 20.16 7.02002 19.56C7.08002 19.18 7.36002 19.22 7.64002 19.2C8.54002 19.3 9.10002 18.92 9.26002 18.02C9.42002 17.86 9.50002 17.56 9.80002 17.58Z"
				fill="black"
			/>
			<path
				d="M34.02 13.0001C34.02 14.0001 33.22 14.7801 32.26 14.7401C31.26 14.7201 30.54 13.9401 30.54 12.9401C30.54 11.9401 31.34 11.1801 32.32 11.2001C33.3 11.2201 34.02 11.9801 34.02 13.0001ZM33.34 12.9601C33.2 12.3801 32.92 11.9401 32.3 11.9401C31.64 11.9401 31.24 12.3601 31.26 13.0001C31.28 13.6401 31.7 14.0201 32.36 13.9801C32.98 13.9401 33.26 13.5201 33.34 12.9601Z"
				fill="black"
			/>
			<path
				d="M21.5802 1.84009C21.5002 2.16009 20.6602 1.80009 21.0202 2.50009C20.4802 3.56009 19.6202 3.54009 18.6602 3.22009C17.4602 2.04009 17.5002 1.16009 18.8402 0.0200922C20.5002 -0.0799078 20.6402 0.0200921 21.3002 1.60009C21.3202 1.72009 21.4802 1.76009 21.5802 1.84009ZM20.5802 1.62009C20.4602 1.02009 20.1202 0.620092 19.4602 0.640092C18.8402 0.680092 18.4802 1.10009 18.5002 1.68009C18.5002 2.28009 18.9002 2.70009 19.5002 2.70009C20.1402 2.70009 20.5402 2.32009 20.5802 1.62009Z"
				fill="black"
			/>
			<path
				d="M20.9598 23.18C20.9598 23.66 21.0198 24.1 21.6998 24C21.6198 24.18 21.5398 24.36 21.4998 24.54C21.1998 25.56 20.6198 26.06 19.6798 25.98C18.7998 25.92 18.2798 25.42 18.1198 24.58C17.9398 23.64 18.3998 23 19.2398 22.64C19.3598 22.58 19.4798 22.56 19.6198 22.52C20.1398 22.56 20.4798 23.04 20.9598 23.18ZM18.7798 24.2C18.7998 24.9 19.1598 25.28 19.7598 25.3C20.3398 25.32 20.8198 24.98 20.7998 24.34C20.7798 23.78 20.5798 23.22 19.8798 23.22C19.2198 23.24 18.8398 23.6 18.7798 24.2Z"
				fill="black"
			/>
			<path
				d="M7.6202 19.1999C7.3602 19.1999 7.0602 19.1799 7.0002 19.5599C6.1202 19.0199 6.0002 18.1999 6.3002 17.3399C6.5602 16.5399 7.2002 16.1599 8.0602 16.1599C9.0002 16.1799 9.5802 16.6799 9.8002 17.5799C9.5002 17.5799 9.4202 17.8799 9.2402 18.0199C9.1002 17.2799 8.7202 16.7799 7.9202 16.8199C7.3002 16.8599 6.9202 17.2799 6.8402 17.9199C6.7802 18.5399 7.1802 18.8799 7.6202 19.1999Z"
				fill="black"
			/>
			<path
				d="M19.8402 17.6001C19.5802 17.6201 19.4002 17.7201 19.3802 18.0201C18.3602 17.4801 17.6402 16.6801 17.1802 15.6201C17.3802 15.3001 17.3802 14.9401 17.4002 14.5801C17.9402 15.8001 18.7202 16.8401 19.8402 17.6001Z"
				fill="black"
			/>
			<path
				d="M12.94 20.76C12.68 20.84 12.6 21.06 12.56 21.3C11.7 20.52 11.34 20.5 10.5 21.26C10.4 21.06 10.32 20.84 10.04 20.82C11.1 19.72 11.9 19.7 12.94 20.76Z"
				fill="black"
			/>
			<path
				d="M17.4199 14.5799C17.3999 14.9399 17.3999 15.2999 17.1999 15.6199C16.6399 14.7399 16.5199 13.7799 16.5799 12.7799C16.8199 12.5199 17.0599 12.4399 17.1399 12.8799C17.2399 13.4199 17.3199 13.9999 17.4199 14.5799Z"
				fill="black"
			/>
			<path
				d="M6.46012 6.41992C6.62012 6.57992 6.78012 6.73992 6.94012 6.89992C6.68012 7.65992 7.20012 8.13992 7.62012 8.63992C7.64012 8.85992 7.54012 8.99992 7.32012 9.01992C6.18012 8.35992 5.96012 7.63992 6.46012 6.41992Z"
				fill="black"
			/>
			<path
				d="M7.2998 9.01988C7.5198 8.99988 7.6198 8.85988 7.5998 8.63988C7.9798 8.55988 8.3598 8.47988 8.7398 8.37988C8.9398 8.47988 8.9998 8.67988 9.0398 8.87988C8.4998 9.29989 7.9198 9.35989 7.2998 9.01988Z"
				fill="black"
			/>
			<path
				d="M9.04023 8.88012C9.00023 8.68012 8.94023 8.50012 8.74023 8.38012C8.90023 8.12012 9.06023 7.86012 9.24023 7.62012C9.46023 7.82012 9.56023 8.08012 9.60023 8.36012C9.48023 8.60012 9.34023 8.82012 9.04023 8.88012Z"
				fill="black"
			/>
			<path
				d="M9.56012 19.0199C9.28013 18.6599 9.36013 18.4599 9.82012 18.4399C9.84012 18.6799 9.70012 18.8399 9.56012 19.0199Z"
				fill="black"
			/>
			<path
				d="M39.2998 22.4199C39.4398 22.4999 39.7598 22.4999 39.4798 22.7599C39.3798 22.8399 39.1598 22.7799 38.9998 22.7799C34.8598 22.7799 30.6998 22.7799 26.5598 22.7799C26.2998 22.7799 26.0198 22.8599 25.8198 22.5999C29.8998 22.5799 33.9598 22.5599 38.0398 22.5199C38.4598 22.5199 38.8998 22.6599 39.2998 22.4199Z"
				fill="black"
			/>
			<path
				d="M10.48 21.24C10.44 21.5 10.42 21.74 10.38 22C10.16 21.72 10.02 21.44 10.48 21.24Z"
				fill="black"
			/>
			<path
				d="M39.6001 21.34C39.6001 15.66 39.6001 9.98005 39.6001 4.30005C39.6401 4.30005 39.6601 4.30005 39.7001 4.30005C39.7001 10 39.7001 15.68 39.7001 21.3801C39.6601 21.3601 39.6201 21.34 39.6001 21.34Z"
				fill="black"
			/>
			<path
				d="M33.34 12.9599C33.26 13.5199 32.98 13.9399 32.36 13.9999C31.68 14.0399 31.26 13.6599 31.26 13.0199C31.24 12.3799 31.66 11.9599 32.3 11.9599C32.92 11.9399 33.22 12.3799 33.34 12.9599Z"
				fill="#FF6B01"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_33_1029"
				x="0"
				y="0"
				width="44"
				height="34"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="2" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_33_1029"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_33_1029"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_33_1029">
				<rect width="36" height="26" fill="white" transform="translate(4)" />
			</clipPath>
		</defs>
	</Icon>
);

export const HeadlinesIcon = () => (
	<Icon>
		<path
			d="M23.9583 0H3.81944C3.24414 0 2.77778 0.466363 2.77778 1.04167V1.38889H1.04167C0.466363 1.38889 0 1.85525 0 2.43056V14.2361C0 15.5785 1.08819 16.6667 2.43056 16.6667H22.9167C24.0673 16.6667 25 15.7339 25 14.5833V1.04167C25 0.466363 24.5336 0 23.9583 0ZM2.43056 14.5833C2.33847 14.5833 2.25015 14.5468 2.18503 14.4816C2.11992 14.4165 2.08333 14.3282 2.08333 14.2361V3.47222H2.77778V14.2361C2.77778 14.3282 2.7412 14.4165 2.67608 14.4816C2.61096 14.5468 2.52264 14.5833 2.43056 14.5833ZM12.6736 13.8889H6.07639C5.78876 13.8889 5.55556 13.6557 5.55556 13.3681V13.0208C5.55556 12.7332 5.78876 12.5 6.07639 12.5H12.6736C12.9612 12.5 13.1944 12.7332 13.1944 13.0208V13.3681C13.1944 13.6557 12.9612 13.8889 12.6736 13.8889ZM21.7014 13.8889H15.1042C14.8165 13.8889 14.5833 13.6557 14.5833 13.3681V13.0208C14.5833 12.7332 14.8165 12.5 15.1042 12.5H21.7014C21.989 12.5 22.2222 12.7332 22.2222 13.0208V13.3681C22.2222 13.6557 21.989 13.8889 21.7014 13.8889ZM12.6736 9.72222H6.07639C5.78876 9.72222 5.55556 9.48902 5.55556 9.20139V8.85417C5.55556 8.56654 5.78876 8.33333 6.07639 8.33333H12.6736C12.9612 8.33333 13.1944 8.56654 13.1944 8.85417V9.20139C13.1944 9.48902 12.9612 9.72222 12.6736 9.72222ZM21.7014 9.72222H15.1042C14.8165 9.72222 14.5833 9.48902 14.5833 9.20139V8.85417C14.5833 8.56654 14.8165 8.33333 15.1042 8.33333H21.7014C21.989 8.33333 22.2222 8.56654 22.2222 8.85417V9.20139C22.2222 9.48902 21.989 9.72222 21.7014 9.72222ZM21.7014 5.55556H6.07639C5.78876 5.55556 5.55556 5.32235 5.55556 5.03472V3.29861C5.55556 3.01098 5.78876 2.77778 6.07639 2.77778H21.7014C21.989 2.77778 22.2222 3.01098 22.2222 3.29861V5.03472C22.2222 5.32235 21.989 5.55556 21.7014 5.55556Z"
			fill="black"
		/>
	</Icon>
);

export const MarketIndicatorsIcon = () => (
	<Icon>
		<g clipPath="url(#clip0_3023_1374)">
			<path
				d="M9.4 11.3433L14.17 3.08326C13.47 2.93326 12.75 2.84326 12 2.84326C9.6 2.84326 7.4 3.69326 5.68 5.09326L9.34 11.4433L9.4 11.3433ZM21.54 9.84326C20.62 6.92326 18.39 4.58326 15.54 3.50326L11.88 9.84326H21.54ZM21.8 10.8433H14.31L14.6 11.3433L19.36 19.5933C21 17.8133 22 15.4533 22 12.8433C22 12.1533 21.93 11.4933 21.8 10.8433ZM8.54 12.8433L4.64 6.09326C3.01 7.87326 2 10.2333 2 12.8433C2 13.5333 2.07 14.1933 2.2 14.8433H9.69L8.54 12.8433ZM2.46 15.8433C3.38 18.7633 5.61 21.1033 8.46 22.1833L12.12 15.8433H2.46ZM13.73 15.8433L9.83 22.6033C10.53 22.7533 11.25 22.8433 12 22.8433C14.4 22.8433 16.6 21.9933 18.32 20.5933L14.66 14.2433L13.73 15.8433Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3023_1374">
				<rect width="24" height="24" fill="white" transform="translate(0 0.843262)" />
			</clipPath>
		</defs>
	</Icon>
);

export const WatchlistIcon = () => (
	<Icon>
		<g clipPath="url(#clip0_3023_9047)">
			<path
				d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3023_9047">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</Icon>
);

export const TopStocksIcon = () => (
	<Icon>
		<path
			d="M7 19.25L3.5 22.68V12.8333H7V19.25ZM12.8333 17.1033L11.0017 15.54L9.33333 17.08V8.16667H12.8333V17.1033ZM18.6667 15.1667L15.1667 18.6667V3.5H18.6667V15.1667ZM21.945 14.945L19.8333 12.8333H25.6667V18.6667L23.5783 16.5783L15.1667 24.92L11.1183 21.3967L6.70833 25.6667H3.5L11.0483 18.27L15.1667 21.7467"
			fill="black"
		/>
	</Icon>
);

export const PortfolioIcon = () => (
	<Icon>
		<PortfolioImage />
	</Icon>
);

export const AlgoStrategiesIcon = () => (
	<Icon>
		<AlgoStrategiesImage />
	</Icon>
);

export const OrderHistoryIcon = () => (
	<Icon>
		<OrderHistoryImage />
	</Icon>
);

export const AccountBalanceIcon = () => (
	<Icon>
		<AccountBalanceImage />
	</Icon>
);

export const AccountInfoIcon = () => (
	<Icon>
		<AccountInfoPath />
		<defs>
			<clipPath id="clip0_699_105560">
				<rect width="27" height="27" fill="white" />
			</clipPath>
		</defs>
	</Icon>
);

export const OpenOrdersIcon = () => (
	<Icon>
		<path
			d="M11.9989 3.4288C11.3935 3.4288 10.7988 3.49256 10.1773 3.6131V0.130723C10.8042 0.0444673 11.3989 0 11.9989 0C15.1171 0 17.9566 1.18883 20.0943 3.13842L21.6694 1.56225C22.2106 1.02221 23.1321 1.40474 23.1321 2.16818V7.81499C23.1321 8.28645 22.7463 8.67219 22.2748 8.67219H16.6279C15.8671 8.67219 15.4814 7.74534 16.0225 7.20959L17.6673 5.56484C16.1564 4.23618 14.1741 3.4288 11.9989 3.4288ZM3.42888 11.9992C3.42888 12.5992 3.48942 13.1778 3.60354 13.7404H0.124833C0.0423253 13.1725 0 12.5939 0 11.9992C0 8.92935 1.15564 6.12202 3.05599 4.00045L1.47602 2.41945C0.935976 1.87941 1.31797 0.956314 2.03375 0.956314H7.7289C8.20037 0.956314 8.58612 1.33991 8.58612 1.81351V7.45604C8.58612 8.22216 7.65926 8.60254 7.12349 8.06679L5.48406 6.42739C4.20359 7.9275 3.42888 9.87227 3.42888 11.9992ZM7.98071 16.9656L6.427 18.5139C7.92714 19.7997 9.87195 20.5712 11.9989 20.5712C12.5668 20.5712 13.1187 20.5176 13.6544 20.4158V23.8875C13.1133 23.9625 12.5615 24 11.9989 24C8.92901 24 6.12162 22.7999 4 20.9462L2.33324 22.6124C1.7932 23.1535 0.869542 22.7678 0.869542 22.007V16.3602C0.869542 15.8887 1.25368 15.503 1.72676 15.503H7.36994C8.08786 15.503 8.51647 16.4245 7.98071 16.9656ZM16.8797 16.1084L18.4334 17.6621C19.7675 16.1566 20.5711 14.1743 20.5711 11.9992C20.5711 11.4206 20.5175 10.858 20.405 10.3116H23.8821C23.9625 10.8634 24 11.4259 24 11.9992C24 15.1173 22.8106 17.9567 20.8658 20.0944L22.5267 21.7552C23.0678 22.2963 22.682 23.2178 21.9212 23.2178H16.2743C15.8028 23.2178 15.4171 22.8321 15.4171 22.3606V16.7138C15.4171 15.953 16.3386 15.5673 16.8797 16.1084Z"
			fill="black"
		/>
	</Icon>
);

export const ClosedOrdersIcon = () => (
	<Icon>
		<path
			d="M10.666 16.6665L14.666 20.6665L21.3327 12.6665"
			stroke="black"
			strokeWidth="2.53017"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.9993 29.3332C23.3631 29.3332 29.3327 23.3636 29.3327 15.9998C29.3327 8.63604 23.3631 2.6665 15.9993 2.6665C8.63555 2.6665 2.66602 8.63604 2.66602 15.9998C2.66602 23.3636 8.63555 29.3332 15.9993 29.3332Z"
			stroke="black"
			strokeWidth="2.53017"
		/>
	</Icon>
);

export const TradeIcon = () => (
	<Icon>
		<path
			d="M16.5002 15.9474C16.5002 14.9471 16.5002 13.9469 16.5002 12.8354C19.1002 14.9471 21.7002 16.9477 24.3002 19.0594C21.7002 21.1711 19.1002 23.1716 16.5002 25.2833C16.5002 24.1719 16.5002 23.1716 16.5002 22.1714C16.3002 22.1714 16.2002 22.1714 16.1002 22.1714C13.7002 22.1714 11.2002 22.1714 8.80019 22.1714C8.60019 22.1714 8.40019 22.0602 8.20019 21.9491C5.80019 20.0597 3.40019 18.1703 1.0002 16.1697C0.900195 16.1697 0.900195 16.0586 0.700195 15.9474C6.00019 15.9474 11.2002 15.9474 16.5002 15.9474Z"
			fill="black"
		/>
		<path
			d="M0 6.94512C2.6 4.83343 5.2 2.83288 7.8 0.721191C7.8 1.83261 7.8 2.83288 7.8 3.83316C8 3.83316 8.1 3.83316 8.2 3.83316C10.6 3.83316 13.1 3.83316 15.5 3.83316C15.7 3.83316 15.9 3.9443 16 4.05544C18.4 5.94485 20.8 7.83425 23.2 9.8348C23.3 9.94594 23.3 9.94594 23.5 10.0571C18.2 10.0571 13 10.0571 7.7 10.0571C7.7 11.0574 7.7 12.0576 7.7 13.1691C5.2 11.0574 2.6 8.94567 0 6.94512Z"
			fill="black"
		/>
	</Icon>
);
